import { observer } from 'mobx-react-lite';

import LoginPopupUI from 'ati-ui-react/unstyled/components/LoginPopup';

import { registration } from 'constants/pages';
import { useStore } from 'hooks/useStore';
import { PopupIds } from 'store/UIStore/Popups';
import { interpolate } from 'utils/string/format';

const LoginPopup = () => {
  const {
    ui: { popups },
    app: { env },
  } = useStore();

  if (typeof window === 'undefined' || !popups.loginPopup?.isOpened) return null;

  const next = `${encodeURIComponent(window.location.href)}`;

  const handleUserLogin = () => {
    const onLogin = popups.loginPopup?.payload?.onLogin;
    if (onLogin) {
      popups.loginPopup?.payload?.onLogin();
    } else {
      location.reload();
    }
  };

  const handleClose = () => {
    popups.close(PopupIds.loginPopup);
  };

  const handleUserRegister = () => {
    window.open(interpolate(registration, { env, next }), '_self');
  };

  return (
    <LoginPopupUI
      fastreg
      baseUrl={`ati.${env}`}
      next={next}
      onLoginClose={handleClose}
      onUserLogin={handleUserLogin}
      onUserRegister={handleUserRegister}
    />
  );
};

const connected = observer(LoginPopup);

export { connected as LoginPopup };
